<template>
  <div class="searchResult">
    <a-spin :spinning="spinning" size="large" tip="加载中...">
    <headerComponent></headerComponent>
    <div class="banner">
        <div class="hotword1">社媒热点</div>
         <a-input-search
      v-model:value="value"
      enter-button="搜索"
       placeholder="请输入搜索内容"
      size="large"
      :loading="loading"
      @search="onSearch"
    />
    </div>
     <div class="noData" v-show="hasData">
      <img src="../../assets/image/noData.png" alt="">
      <div>暂无搜索数据</div>
    </div>
    <div class="tab" v-show="!hasData">
      <a-tabs hide-add  v-model:activeKey="activeKey"  @change="callback">
        <a-tab-pane :tab="swictchName(hz.name,hz.total)"  v-for="(hz,index1) in list" :key="hz.id">
          <div class="box1">
            <div class="screen">
              <div class="result">查询结果：{{formatNum1(hz.total)}}条</div>
              <div class="screenright">
                <div class="px">排序方式：</div>
                <!-- 下拉 -->
                <a-dropdown>
                <a class="ant-dropdown-link">
                  {{sortName}}
                  <DownOutlined />
                </a>
                <template #overlay>
                  <a-menu>
                    <a-menu-item>
                      <a @click.prevent="changeType(0)">最新发布</a>
                    </a-menu-item>
                    <a-menu-item>
                      <a  @click.prevent="changeType(1)">最高热度</a>
                    </a-menu-item>
                  </a-menu>
                </template>
              </a-dropdown>
              <!-- 下拉 -->
              <!-- 日期 -->
            <a-space direction="vertical">
              <a-range-picker @change="onCalendarChange" v-model:value="value3" />
            </a-space>
            <!-- 日期 -->
              </div>
            </div>
          <div class="content">
           
            <div class="content1" :class="{text2:!list.topUrl}" v-for="(list,index) in list[index1].text" :key="list.id" @click="turnPath(list.topUrl)">
              <!-- <div class="tit">{{list.title}}</div>
              <p class="dl" v-if="list.subTitle">{{list.subTitle}}</p>
              <span class="name1">发布在</span>
              <span class="name">{{list.topSource}}</span>
              <div class="star">
                <div class="rq">{{list.receiveDate}}</div>
              </div> -->
                <div class="number">{{((form.pageNum-1)*form.pageSize)+(index+1)}}</div>
                <div :class="{test2:list.subTitle}" class="text1">{{list.title}}</div>
                <div v-if="list.subTitle" class="test3">{{list.subTitle}}</div>
                <div class="time">{{switchTime(list.receiveDate)}}</div>
                <div class="hot">{{formatNum(list.topNum,hz.name)}}</div>
                <RightOutlined />
            </div>
            <!-- <div class="jzbutton" v-show="showMore" @click="homeSit">加载更多</div> -->
            <a-pagination  show-quick-jumper v-model:current="current1" show-size-changer :page-size="form.pageSize" @showSizeChange="onShowSizeChange"  :page-size-options="pageSizeOptions" :total="list[index1].total" @change="onChange" />
          </div>
          </div>
        </a-tab-pane>
      </a-tabs>
      <div class="hoverBottomWapper"> 
      <div class="hoverBottom1">
        <a  style="display:inline-block;text-decoration:none;height:20px;line-height:20px;"><img src="../../assets/beian.png" style="float:left;"/>
        <p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;"><a href="http://www.beian.gov.cn/" target="_blank">粤公网安备 44011202001572号</a> | <a href="https://beian.miit.gov.cn" target="_blank" >粤ICP备2021056281号</a> </p ></a>
    </div>
    </div>
  </div>
    </a-spin>
  </div>
</template>
<script>
import { message } from 'ant-design-vue'
import headerComponent from '../../components/hotHeader'
import { DownOutlined,RightOutlined } from '@ant-design/icons-vue';
import { getHotList,getHotDetail } from '../../utils/api';
import {  h } from 'vue';
export default {
components: {
    headerComponent,
    DownOutlined,
    RightOutlined
  },
  data() {
    return {
      list:[],
      defaultList:[],
      defaultKey:'',
      activeKey:'',
      sortName:'最新发布',
      current1:1,
      pageSizeOptions:['50','100','150','200'],
      curId:"",
      loading:false,
      total:0,
      value3:null,
      hasData:true,
      list1:[],
      spinning:true,
      value: this.$route.query.title?this.$route.query.title:'',
      form:{
        pageNum:1,
        pageSize:50,
        startTime:'',
        endTime:'',
        title: this.$route.query.title?this.$route.query.title:'',
        orderByColumn:'receiveDate'
      }
    };
  },
  mounted(){
    this.getIndex();
  },
  methods: {
    switchTime(val){
      if(val){
        if(val.indexOf('/')!=-1){
          return val.replace(/\//g,'-')
        }else{
          return val.substring(0,val.length-3)
        }
      }else{
        return ''
      }
    },
    swictchName(name,num){
      return [h("span", name), h('span',{class:'num1'},"("+this.formatNum1(num)+")"),h('span',{class:'num3'})];
    },
    async getIndex(){
      let that = this
      await getHotList().then(res=>{
        // this.defaultList = res.rows
        res.rows.map((cur)=>{
            that.defaultList.push(cur.id)
            that.spinning = true
            that.xianQ1(cur.id,that.form,cur.name)
        })
      })
    },
    formatNum(val,id){
      if(id=='抖音品牌话题榜单（所有行业）'){
        return this.formatNum1(val)
      }
      if(val){
        return (val/10000).toFixed(0) + ' 万热度'
      }else{
        return ''
      }
    },
    async xianQ1(c,form,name){
      let that = this
      await getHotDetail(c,form).then(res=>{
        // if(value==''&c=='1425304277989965826'){
        //   that.spinning = false
        // }else{
           that.spinning = false
        // }
         that.loading = false;
         if(res.rows){
           that.hasData = false;
            if(that.curId==''){
              that.curId = c
            }
            that.list.push({
              id:c,
              name: name,
              text: res.rows,
              total: res.total
            })
            that.list.sort(function(a,b){
                return that.defaultList.indexOf(a.id)-that.defaultList.indexOf(b.id);
            })
            // that.activeKey = c
            that.list.map((cur,index)=>{
              if(index==0){
                  that.activeKey = cur.id
                  that.curId = cur.id
              }
            })
            
            console.log(that.list)
              // that.list.map((cur,index)=>{
              //     if(c==cur.id){
              //       that.list[index].total = res.total
              //       that.list[index].text = res.rows
                  
              //     }
              // })
         }else{
            // that.list.map((cur,index)=>{
            //     if(c==cur.id){
            //         that.list.splice(index,1)
            //     }
            // })
         }
       })
    },
    onShowSizeChange(current, pageSize){
      // this.list1 = [];
      this.form.pageSize = pageSize;
      this.current1 = 1;
      this.spinning = true;
      this.form.pageNum = 1;
      this.xianQ(this.curId,this.form)
    },
    onChange(pageNumber){
      // this.list1 = []
      this.spinning = true;
      this.form.pageNum  = pageNumber;
      this.xianQ(this.curId,this.form)
    },
    changeType(val){
      // let that = this
      // that.list.map((cur,index)=>{
      //     if(cur==cur.id){
      //       that.list[index].text = []
      //     }
      // })
      this.spinning = true;
      if(val==0){
        this.sortName = '最新发布'
        this.form.orderByColumn = 'receiveDate'
        this.current1 = 1;
        this.form.pageNum = 1;
        this.form.pageSize = 50;
        this.xianQ(this.curId,this.form)
      }else{
        this.sortName = '最高热度'
        this.current1 = 1;
        this.form.pageNum = 1;
        this.form.pageSize = 50;
        this.form.orderByColumn = 'topNum'
        this.xianQ(this.curId,this.form)
      }
    },
    onSearch(){
      if(this.value==''){
          message.error('请输入搜索内容')
          return
      }
      this.hasData = true;
      this.form.title = this.value;
      this.current1 = 1;
      this.loading = true;
      this.form.pageNum = 1;
      this.form.pageSize = 50;
      this.spinning = true;
      this.list = []
      this.getIndex()
      // this.xianQ(this.curId,this.form)
    },
    turnPath(a){
       if(a){
          window.open(a)
        }
    },
    homeSit(){
      this.form.pageNum = this.form.pageNum + 1;
      this.xianQ(this.curId,this.form)
    },
    xianQ(c,form){
      let that = this
      that.total = 0;
      // that.activeKey = c
      getHotDetail(c,form).then(res=>{
        that.spinning = false
        if(res.rows){
          that.list.map((cur,index)=>{
              if(c==cur.id){
                that.list[index].total = res.total
                that.list[index].text = res.rows
                // that.curId = c
                // that.list1 = res.rows
                // that.total = res.total
              }
          })
          // res.rows.map((cur)=>{
          //   that.list1.push(cur)
          // })
          // that.total = res.total
          // if(res.total!=0){
          //   that.showMore = true
          // }else{
          //   that.showMore = false
          // }
        }
      })
    },
    onCalendarChange(val,mode){
      this.form.startTime = mode[0].replace(/-/g, '')
      this.form.endTime = mode[1].replace(/-/g, '')
      let that = this
      that.list.map((cur,index)=>{
          if(cur==cur.id){
            that.list[index].text = []
          }
      })
      this.current1 = 1;
      this.form.pageNum = 1;
      this.form.pageSize = 50;
      this.xianQ(this.curId,this.form)
    },
    formatNum1(n){
            if(n<0||!n){
                return 0
            }
            let num = n.toString()
            let decimals = ''
                // 判断是否有小数
            num.indexOf('.') > -1 ? decimals = num.split('.')[1] : decimals
            let len = num.length
            if (len <= 3) {
                return num
            } else {
                let temp = ''
                let remainder = len % 3
                decimals ? temp = '.' + decimals : temp
                if (remainder > 0) { // 不是3的整数倍
                    return num.slice(0, remainder) + ',' + num.slice(remainder, len).match(/\d{3}/g).join(',') + temp
                } else { // 是3的整数倍
                    return num.slice(0, len).match(/\d{3}/g).join(',') + temp
                }
            }
        },
    callback(key) {
      // this.list1=[]
      let that = this
      this.spinning = true;
      this.list.map((cur,index)=>{
          if(key==cur.id){
            that.list[index].text = []
          }
      })
      this.current1 = 1
      this.form.pageNum = 1;
      this.form.pageSize = 50;
      this.curId= key;
      this.xianQ(key,this.form)
      console.log(key);
    },
  },
}
</script>

<style lang="scss" scoped>
/deep/.ant-dropdown{
  text-align: center;
  background: #000 !important ;
}
/deep/.ant-dropdown-menu {
  text-align: center !important ;
}
.searchResult{
   font-family: 'NotoSansSC',sans-serif;
    .hoverBottomWapper{
    width: 100%;
    background-color: #333;
    padding: 10px 0;
    .hoverBottom1{
      position: relative;
      width:100%;
      // text-align:center;
      //  padding:0px 0 10px 0;
      width:fit-content;
      margin: 0 auto;
      display: block;
      text-align:center;
       p>a{
          color: rgb(147, 147, 147);
           position: relative;
          padding-bottom: 5px;
          &::after{
              content: "";
              display: block;
              height: auto;
              border-bottom: 0!important;
              background-image: linear-gradient(#00f000,#00f000);
              text-decoration: none;
              padding-bottom: 2px;
              background-position: 0 100%;
              background-repeat: no-repeat;
              background-size: 0 2px;
              transition: background-size .3s;
              position: absolute;
              bottom: 0;
              left: 0;
              width: 100%;
          }
          &:hover{
              color: #00F000;
              // border-bottom: 1px solid #00F000;
              // background-size: 100% 2px
              &::after{
                  background-size: 100% 2px
              }
          }
        }
    }
  }
   
   /deep/.ant-spin-blur{
        opacity: .75;
    }
    /deep/.ant-spin-nested-loading > div > .ant-spin{
        position: fixed;
        top: 50%;
        transform: translateY(-50%);
        z-index: 99;
    }
    /deep/.ant-spin-container::after{
        // background-color: transparent;
        display: none;
    }
    /deep/.ant-spin{
        color: #62f662;
        font-size: 30px;
        .ant-spin-dot-item{
            background-color: #62f662;
        }
    }
   /deep/.ant-tabs-tab-btn-disabled svg{
     color: #676767!important;
     &:hover{
       color: #676767!important;
     }
   }
   /deep/.ant-tabs-tab-prev-icon svg{
     color: #fff;
     font-size: 14px;
     &:hover{
       color: #00f000;
     }
   }
   /deep/.ant-tabs-tab-next-icon svg{
     color: #fff;
     font-size: 14px;
      &:hover{
       color: #00f000;
     }
   }
   .num1{
     font-size: 13px;
     margin-left: 5px;
   }
   .noData{
    text-align: center;
    margin-top: 80px;
    img{
      width: 120px;
    }
    div{
      font-size: 24px;
      margin-top: 10px;
    }
  }
   /deep/.ant-pagination{
        float: right;
        margin: 0.16rem 0;
    }
    /deep/.ant-input-search{
            .ant-input{
                &:focus{
                    border-bottom: 2px solid #00f000;
                }
            }
    }
    // /deep/.ant-tabs-nav-container-scrolling{
    //   padding-left: 0;
    //   padding-right: 0;
    // }
    // /deep/.ant-tabs-nav .ant-tabs-tab{
    //   padding-left: 0;
    //   padding-right: 0;
    // }
    .banner{
            width: 100%;
            height: 318px;
            background-image:url(../../assets/image/xx.png);
            background-size: 100% 100%;
        }
    .content{
      background-color: #fff;
      margin: 0 151px 0 153px;
      border-radius: 5px;
      // margin: auto;
      padding: 30px 60px 81px 60px;
      
      .jzbutton{
        width: 144px;
        height: 37px;
        line-height: 37px;
        font-size: 16px;
        color: #666666;
        border-radius: 3px;
        border: 1px solid #C9C9C9;
        text-align: center;
        margin: auto;
        margin-top: 60px;
        cursor: pointer;
      }
      .content1{
        border-bottom: 1px solid #d9d9d9;
        cursor: pointer;
        display: flex;
        align-items: center;
        padding: 20px 0px;
        &.text2{
            cursor: default;
            .text1{
                &::after{
                    display: none;
                }
                &:hover{
                    color: rgba(0, 0, 0, 0.85);
                }
            }
            .test3{
                &::after{
                    display: none;
                }
                &:hover{
                    color: rgba(0, 0, 0, 0.85);
                }
            }
        }
        .hot{
          flex: 1;
          margin-left: 15px;
          text-align: right;
        }
        .anticon{
          margin-left: 2%;
        }
        .number{
            width: 50px;
            text-align: left;
        }
        .test3{
            overflow: hidden;/*超出部分隐藏*/
            text-overflow:ellipsis;/* 超出部分显示省略号 */
            white-space: nowrap;/*规定段落中的文本不进行换行 */
            width: 33%;
            margin-left: 2%;
            font-size: 16px;
            position: relative;
            &::after{
              content: "";
              display: block;
              height: auto;
              border-bottom: 0!important;
              background-image: linear-gradient(#00f000,#00f000);
              text-decoration: none;
              padding-bottom: 2px;
              background-position: 0 100%;
              background-repeat: no-repeat;
              background-size: 0 2px;
              transition: background-size .3s;
              position: absolute;
              bottom: 0;
              left: 0;
              width: 100%;
          }
          &:hover{
              color: #00F000;
              // border-bottom: 1px solid #00F000;
              // background-size: 100% 2px
              &::after{
                  background-size: 100% 2px
              }
        }
        }
        .text1{
            overflow: hidden;/*超出部分隐藏*/
            text-overflow:ellipsis;/* 超出部分显示省略号 */
            white-space: nowrap;/*规定段落中的文本不进行换行 */
            width: 70%;
            font-size: 16px;
            position: relative;
            &.test2{
              width: 35%;
            }
            &::after{
            content: "";
              display: block;
              height: auto;
              border-bottom: 0!important;
              background-image: linear-gradient(#00f000,#00f000);
              text-decoration: none;
              padding-bottom: 2px;
              background-position: 0 100%;
              background-repeat: no-repeat;
              background-size: 0 2px;
              transition: background-size .3s;
              position: absolute;
              bottom: 0;
              left: 0;
              width: 100%;
          }
          &:hover{
              color: #00F000;
              // border-bottom: 1px solid #00F000;
              // background-size: 100% 2px
              &::after{
                  background-size: 100% 2px
              }
          }
        }
        .time{
          flex: 1;
          text-align: right;
          margin-left: 10px;
        }
        .tit{
          font-size: 20px;
          color: #000000;
          font-weight: bold;
        }
        .label{
          display: flex;
          align-items: center;
        }
        .label1{
          color: #333333;
          font-size: 14px;
          width: 110px;
          line-height: 37px;
          background-color: #D9D9D9;
          border-radius: 6px;
          text-align: center;
          margin-right: 29px;
        }
        .dl{
          text-align: justify;
          padding: 24px 530px 38px 0px;
          margin: 0;
        }
        .tou{
          width: 36px;
          border-radius: 50%;
          margin-right: 19px;
        }
        .name{
          font-size: 16px;
          color: #333333;
        }
        .name1{
          font-size: 16px;
          color: #666;
          margin-right: 12px;
        }
        .sc{
          width: 20px;
        }
        .star{
          margin-top: 16px;
          margin-bottom: 42px;
          font-size: 16px;
          color: #B3B3B3;
          display: flex;
          justify-content: space-between;
        }
        .number{
          line-height: 18px;
        }
        .starbox{
          height: 9px;
          flex: 1;
          display: flex;
          align-items: center;
          width: 103px;
          border-right: 1px solid #e5e5e5;
          justify-content: space-evenly;
        }
        .starbox:nth-of-type(3n){
          border-right: 0;
        }
        .allbox{
          display: flex;
          align-items: center;
        }
        .rq{
          padding-right: 530px;
        }
      }
    }
    .hotword1{
      font-size: 32px;
      color: #FFFFFF;
      width: 100%;
      text-align: center;
      padding-top: 66px;
    }
    .box1{
      background-color: #333;
      min-height: 100vw;
    }
    .screen{
      font-size: 16px;
      padding: 20px 151px 16px 213px;
      color: #C9C9C9; 
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    .screenright{
      display: flex;
      align-items: center;
      // 下拉
      a {
      color: #333 !important;
      background-color: #00F000;
      font-size: 20px;
      width: 142px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      border-radius: 3px; 
      // margin-right: 41px;
      }
    }
    // 日期
    /deep/.ant-space-item{
      width: 250px;
      height: 38px;
      padding: 0;
      display: none;
    }
    /deep/.ant-input{
      padding: 0;
      height: 38px;
    }
    /deep/.ant-calendar-picker-input{
      height: 38px!important;
      line-height: 38px!important;
    }
// 这是tab
    .tab{
      margin-top: -60px;
    }
    /deep/.ant-tabs-bar{
      margin-left: 213px;
      margin-right: 151px;
      margin-bottom: 0;
      border-bottom: 0;
    }
    /deep/.ant-tabs-tab{
      color: #fff;
      font-size: 24px;
      position: relative;
      &:last-child{
        .num3{
          display: none;
        }
      }
      .num3{
        width: 1px;
        height: 11px;
        background-color: #fff;
        position: absolute;
        right: -12px;
        top: 50%;
        transform: translateY(-50%);
      }
    }
    /deep/.ant-tabs-tab-active{
      color: #00F000;
    }
    /deep/.ant-tabs-ink-bar{
      background-color: #00F000;
    }
    /deep/.ant-tabs-nav-wrap{
      margin-bottom: 0px;
    }
// 这是tab
// 这是搜索
    /deep/.ant-input-lg{
      font-size: 24px;
      padding: 14px 0px 13px 20px;
    }
    /deep/.ant-input-group{
        width: 585px;
        margin: 0 auto;
        margin-top: 27px;
    }
     /deep/.ant-input{
        height: 50px;
        line-height: 50px;
    }
    /deep/.ant-input-search-button{
        border-radius: 0;
    }
    /deep/.ant-input-search-button:hover{
        background-color: #000000;
        border-color:#000000;
    }
    /deep/.ant-btn, .ant-btn:active, .ant-btn:focus{
        line-height: 52px;
        height: 52px;
        font-size: 24px;
        background-color: #000000;
        border-color:#000000;
    }
// 这是搜索
}
</style>